import { render, staticRenderFns } from "./MeetingPurposeForm.vue?vue&type=template&id=1832c4d5&"
import script from "./MeetingPurposeForm.vue?vue&type=script&lang=js&"
export * from "./MeetingPurposeForm.vue?vue&type=script&lang=js&"
import style0 from "./MeetingPurposeForm.vue?vue&type=style&index=0&id=1832c4d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports